module.exports = __webpack_public_path__ + "static/img/img_ny_clw_dz.e8be2eec.png";